const checkAuth = () => {
  let token = localStorage.getItem("token");
  return token !== null && token !== undefined;
};
const getVendorType = () => {
  let vendor = JSON.parse(localStorage.getItem('user'));
  return vendor !== null ?  vendor['vendor_type'] : null;
};
export {
  checkAuth,
  getVendorType
};
